import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=7f1ff384&"
import script from "./Scoreboard.vue?vue&type=script&lang=ts&"
export * from "./Scoreboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports